import React from 'react';
import { motion } from 'framer-motion';
import { ScissorsIcon, FileEditIcon, ClockIcon, LayoutDashboardIcon } from 'lucide-react';
import { Container } from '../components/Container';
const items = [{
  icon: ScissorsIcon,
  name: 'Intelligent PDF splitting',
  desc: 'Combined PDFs split into the right items, automatically.'
}, {
  icon: FileEditIcon,
  name: 'Auto-generated forms',
  desc: 'Pre-filled forms with interactive fields generated for you.'
}, {
  icon: ClockIcon,
  name: 'Automatic reminders',
  desc: 'Smart reminders sent on your cadence, showing what is outstanding.'
}, {
  icon: LayoutDashboardIcon,
  name: 'Centralized tracking',
  desc: 'One view of every outstanding item across your pipeline.'
}];
export function EverythingElse() {
  return <section className="relative overflow-hidden border-t border-white/5 bg-zinc-900/30 py-12 sm:py-16" data-id="element-732">
      <Container className="relative" data-id="element-733">
        <div className="mx-auto mb-10 max-w-2xl text-center" data-id="element-734">
          <h2 className="font-serif-display text-[2.85rem] leading-[1.02] tracking-tight text-white sm:text-4xl sm:leading-[1.05] lg:text-5xl" data-id="element-735">
            And <span className="italic text-accent" data-id="element-736">so much more.</span>
          </h2>
        </div>

        {/* Mobile: compact horizontal rows — icon + name + desc on one tight line each. ~1/3 the height of stacked cards. */}
        <ul className="divide-y divide-white/[0.06] overflow-hidden rounded-2xl border border-white/[0.06] bg-white/[0.02] sm:hidden" data-id="element-737">
          {items.map((it, i) => <motion.li key={it.name} initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '400px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.04,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex items-center gap-3 px-4 py-3" data-id="element-738">
              <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg border border-white/[0.08] bg-accent/[0.08]" data-id="element-739">
                <it.icon className="h-3.5 w-3.5 text-accent" data-id="element-740" />
              </div>
              <div className="min-w-0 flex-1" data-id="element-741">
                <div className="text-[15px] font-semibold leading-tight tracking-tight text-white" data-id="element-742">
                  {it.name}
                </div>
                <div className="mt-0.5 text-xs leading-snug text-zinc-500" data-id="element-743">
                  {it.desc}
                </div>
              </div>
            </motion.li>)}
        </ul>

        {/* Desktop: full card grid */}
        <ul className="hidden gap-3 sm:grid sm:grid-cols-2 lg:grid-cols-4" data-id="element-744">
          {items.map((it, i) => <motion.li key={it.name} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '400px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05,
          ease: [0.16, 1, 0.3, 1]
        }} className="surface relative overflow-hidden p-5" data-id="element-745">
              <div className="relative flex h-9 w-9 items-center justify-center rounded-lg border border-white/[0.08] bg-accent/[0.08]" data-id="element-746">
                <it.icon className="h-4 w-4 text-accent" data-id="element-747" />
              </div>
              <h3 className="relative mt-4 text-[15px] font-semibold tracking-tight text-white" data-id="element-748">
                {it.name}
              </h3>
              <p className="relative mt-1.5 text-xs leading-relaxed text-zinc-400" data-id="element-749">
                {it.desc}
              </p>
            </motion.li>)}
        </ul>
      </Container>
    </section>;
}